import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import CollapseBlock from '../blocks/CollapseBlock/CollapseBlock.jsx';
import { RawHtml } from '../index.jsx';
import FormButtonsContainer from '../../antd/form/FormButtonsContainer/FormButtonsContainer.jsx';
import FormButton from '../../antd/form/FormButton/FormButton.jsx';
import { routes } from '../../../utils/helpers/ApiClient.jsx';
import { useSelector } from 'react-redux';
import '../styles/DetailTable.sass';
import '../styles/RichContent.sass';

const FjJobDetail = ({ jobData }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isLoggedIn, user } = useSelector((state) => state.auth);
  const isStudent = user && user.roles.some((role) => role.name === 'Študent');
  const location = useLocation();
  return (
    <>
      <div className="detail-collapse">
        <CollapseBlock collapsible title={t('Základné informácie')} style={{ marginBottom: '16px' }}>
          <table className="table table-striped detail-info-table">
            <tbody>
              <tr>
                <td>
                  <b>{t('FRI partner')}</b>
                </td>
                <td>{jobData.external_partner.name}</td>
              </tr>
              <tr>
                <td>
                  <b>{t('Názov pracovnej ponuky')}</b>
                </td>
                <td>{jobData.title}</td>
              </tr>
              <tr>
                <td>
                  <b>{t('Počet pozícií')}</b>
                </td>
                <td>{jobData.capacity}</td>
              </tr>
              <tr>
                <td>
                  <b>{t('Miesto výkonu práce')}</b>
                </td>
                <td>{jobData.place_of_work}</td>
              </tr>
              <tr>
                <td>
                  <b>{t('Dátum nástupu')}</b>
                </td>
                <td>{jobData.date_of_start}</td>
              </tr>
              <tr>
                <td>
                  <b>{t('Ponúkaný plat')}</b>
                </td>
                <td>{jobData.salary}</td>
              </tr>
            </tbody>
          </table>
        </CollapseBlock>

        <CollapseBlock collapsible title={t('Popis pracovnej ponuky')}>
          <div className="detail-rich-section">
            {jobData.description ? (
              <RawHtml className="rich-content rich-content--lead add-icons-to-file-anchors">
                {jobData.description}
              </RawHtml>
            ) : (
              '–'
            )}
          </div>
        </CollapseBlock>

        <CollapseBlock collapsible title={t('Rozšírené informácie')}>
          <table className="table table-striped detail-info-table">
            <tbody>
              <tr>
                <td>
                  <b>{t('Kontaktná osoba')}</b>
                </td>
                <td>{jobData.external_partner.contact_person.full_name}</td>
              </tr>
              <tr>
                <td>
                  <b>{t('Kontaktný e-mail')}</b>
                </td>
                <td>{jobData.external_partner.contact_person.email}</td>
              </tr>
              <tr>
                <td>
                  <b>{t('Kontaktné telefónne číslo')}</b>
                </td>
                <td>{jobData.external_partner.contact_person.phone_number}</td>
              </tr>
              <tr>
                <td>
                  <b>{t('Typ pracovnej ponuky')}</b>
                </td>
                <td>
                  {jobData.job_types.map(function (item, i) {
                    return <p key={i}>{item.name}</p>;
                  })}
                </td>
              </tr>
              <tr>
                <td>
                  <b>{t('Vhodné pre študijné programy')}</b>
                </td>
                <td>
                  {jobData.study_programs.map(function (item, i) {
                    return (
                      <p
                        key={i}
                      >{`${item.name} (${item.study_program_type.shortcut})`}</p>
                    );
                  })}
                </td>
              </tr>
              <tr>
                <td>
                  <b>{t('Platnosť od')}</b>
                </td>
                <td>{new Date(jobData.date_from).toLocaleDateString()}</td>
              </tr>
              <tr>
                <td>
                  <b>{t('Platnosť do')}</b>
                </td>
                <td>{new Date(jobData.date_to).toLocaleDateString()}</td>
              </tr>
            </tbody>
          </table>
        </CollapseBlock>
      </div>
      {(!isLoggedIn || isStudent) && (
        <FormButtonsContainer>
          <FormButton
            onClick={() => {
              navigate(`${routes.cmsFriJobsInterestCreate}/${jobData.id}`, {
                state: { date_from: location },
              });
            }}
          >
            {isLoggedIn
              ? t('Mám záujem o pracovnú ponuku')
              : t('Som študent FRI a mám záujem o pracovnú ponuku')}
          </FormButton>
        </FormButtonsContainer>
      )}
    </>
  );
};

FjJobDetail.propTypes = {
  jobData: PropTypes.object,
};

export default FjJobDetail;
